import type { GutXAxisCondition } from '@repo/types';

/**
 * Orders an organ's conditions for the conditions list: the ones the user
 * reported in their survey first, then the rest, each group alphabetical by name.
 */
export function sortConditionsReportedFirst(
  conditions: GutXAxisCondition[],
): GutXAxisCondition[] {
  return [...conditions].sort(
    (a, b) =>
      Number(b.marked_in_survey) - Number(a.marked_in_survey) ||
      a.display_name.localeCompare(b.display_name),
  );
}
